import { uniqueId } from 'lodash';

import {
  EnvironmentAttributes,
  EnvironmentProduction,
  EnvironmentRelationships,
  EnvironmentSandbox,
  EnvironmentStatus,
} from 'dashboard/models/environment';
import { ApiModel } from 'lib/interfaces/api';

export const generateEnvironmentId = () => uniqueId('env_');

export function createMockEnvironmentProduction(
  attributes?: Partial<EnvironmentAttributes>,
  relationships?: Partial<EnvironmentRelationships>,
  id?: string,
): EnvironmentProduction {
  return {
    attributes: {
      name: 'Production',
      'workflow-secret-key': 'persona_production_123-abc',
      status: EnvironmentStatus.Active,
      quotas: [],
      ...attributes,
    },
    type: ApiModel.EnvironmentProduction,
    id: id ?? 'env_production',
    relationships: {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'api-keys': { data: null },
      ...relationships,
    },
  };
}

export function createMockEnvironmentSandbox(
  attributes?: Partial<EnvironmentAttributes>,
  relationships?: Partial<EnvironmentRelationships>,
  id?: string,
): EnvironmentSandbox {
  return {
    attributes: {
      name: 'Sandbox',
      'workflow-secret-key': 'persona_production_123-abc',
      status: EnvironmentStatus.Active,
      quotas: [],
      ...attributes,
    },
    type: ApiModel.EnvironmentSandbox,
    id: id ?? 'env_sandbox',
    relationships: {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'api-keys': { data: null },
      ...relationships,
    },
  };
}
